import { render } from "./RestaurantOrderDetails.vue?vue&type=template&id=fe3e97bc"
import script from "./RestaurantOrderDetails.vue?vue&type=script&lang=js"
export * from "./RestaurantOrderDetails.vue?vue&type=script&lang=js"

import "./RestaurantOrderDetails.vue?vue&type=style&index=0&id=fe3e97bc&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__